var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494f5a",
    d: "M2.5 4.33 5 0H0z"
  })));
};
export default SvgCaret;